import React from 'react';
import type { CSSProperties } from 'react';
import { useTheme } from '@/presentation/contexts/ThemeContext';
import { useResponsiveDesign } from '@/presentation/responsiveDesign/responsiveDesign';
import { qaAttr, type QaAttrOptions } from '@/presentation/utils/qaAttr';

interface AssetIconProps {
  path: string;
  width?: number;
  height?: number;
  color?: string;
  rotationAngle?: number | null;
  transition?: string;
  style?: CSSProperties;
  /** Optional QA tag spread onto the icon node (icons are often the only clickable node). */
  qa?: QaAttrOptions;
}

export const AssetIcon: React.FC<AssetIconProps> = ({
  path,
  width,
  height,
  color,
  rotationAngle = null,
  transition,
  style,
  qa,
}) => {
  const { theme } = useTheme();
  const responsive = useResponsiveDesign();

  return (
    <div
      {...(qa ? qaAttr(qa) : {})}
      style={{
        width: width ?? responsive.icon.medium,
        height: height ?? responsive.icon.medium,
        backgroundColor: color ?? theme.icon.primary,
        WebkitMaskImage: `url(${path})`,
        maskImage: `url(${path})`,
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        maskPosition: 'center',
        ...(rotationAngle !== null ? { transform: `rotate(${rotationAngle}deg)` } : {}),
        ...(transition ? { transition } : {}),
        ...style,
      }}
    />
  );
};
